module.exports = __webpack_public_path__ + "23f492a287981beb4bd2b07ee52b884f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/taco.png
// module id = 2749
// module chunks = 0